const newMessage = async (name = '', email = '', subject = '', message = '') => {
//   console.log('contact message: ' + name + ' ' + email + ' ' + subject + ' ' + message)
}

export default {
  newMessage
}
